export default "__VITE_ASSET__f58f648b__"